var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "round",
        style: { height: _vm.height },
        attrs: { id: "base" }
      },
      [
        _vm.isLoading
          ? _c("div", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoading,
                  expression: "isLoading"
                }
              ],
              attrs: {
                id: "loader",
                "element-loading-text": "Carregando camadas..."
              }
            })
          : _vm._e(),
        _c("div", { staticClass: "round", attrs: { id: "mapa" } }),
        _c("transition", { attrs: { name: "slide" } }, [
          _vm.isCamadasOpen
            ? _c("div", { attrs: { id: "camadas" } }, [
                _c("div", { attrs: { id: "content" } }, [
                  _c("div", { attrs: { id: "header" } }, [
                    _c("span", { attrs: { id: "title" } }, [_vm._v("Camadas")])
                  ]),
                  _c(
                    "div",
                    { attrs: { id: "body" } },
                    [
                      _vm._l(_vm.camadas, function(item) {
                        return _c("div", { staticClass: "item" }, [
                          _c(
                            "div",
                            { staticClass: "check" },
                            [
                              _c("el-checkbox", {
                                attrs: { disabled: _vm.isLoading },
                                on: { change: _vm.changeCheckboxCamadas },
                                model: {
                                  value: item.checked,
                                  callback: function($$v) {
                                    _vm.$set(item, "checked", $$v)
                                  },
                                  expression: "item.checked"
                                }
                              }),
                              _c("img", {
                                staticClass: "legend",
                                class: { border: item.layerId === 3 },
                                attrs: {
                                  src:
                                    _vm.urlCamadas +
                                    "/" +
                                    item.layerId +
                                    "/images/" +
                                    item.legend[0].url
                                }
                              })
                            ],
                            1
                          ),
                          _c("div", { staticClass: "checkbox" }, [
                            _c("span", [_vm._v(_vm._s(item.layerName))])
                          ])
                        ])
                      }),
                      _vm._l(_vm.camadasButton, function(item) {
                        return _c("div", { staticClass: "item" }, [
                          _c(
                            "div",
                            { staticClass: "check" },
                            [
                              _c("el-checkbox", {
                                attrs: { disabled: _vm.isLoading },
                                on: { change: _vm.changeCheckboxCamadasButton },
                                model: {
                                  value: item.checked,
                                  callback: function($$v) {
                                    _vm.$set(item, "checked", $$v)
                                  },
                                  expression: "item.checked"
                                }
                              }),
                              _c("div", {
                                staticClass: "legend",
                                class: item.class
                              })
                            ],
                            1
                          ),
                          _c("div", { staticClass: "checkbox" }, [
                            _c("span", [_vm._v(_vm._s(item.layerName))])
                          ])
                        ])
                      })
                    ],
                    2
                  )
                ])
              ])
            : _vm._e(),
          _vm.isAdicionandoPonto
            ? _c("div", { attrs: { id: "camadas" } }, [
                _c("div", { attrs: { id: "content" } }, [
                  _c("div", { attrs: { id: "header" } }, [
                    _c("span", { attrs: { id: "title" } }, [
                      _vm._v("Adicionar ponto")
                    ])
                  ]),
                  _c("div", { attrs: { id: "body" } }, [
                    _c("span", [_vm._v("Selecione um ponto no mapa")])
                  ])
                ])
              ])
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65a8c974", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65a8c974","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppMapa.vue
// module id = null
// module chunks = 